import React, { useEffect, useState } from "react";
import { fetchItems, createItem } from "../api";
import ItemRow from "../components/ItemRow";

export default function CombinedPage() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const [fontColor, setFontColor] = useState("#ffffff");
  const [fontSize, setFontSize] = useState(40);
  const [dragIndex, setDragIndex] = useState(null);

  useEffect(() => {
    fetchItems().then(setItems);
  }, []);

  async function add(e) {
    e.preventDefault();
    if (!text.trim()) return;

    const payload = {
      text: text.trim(),
      fontColor,
      fontSize: Number(fontSize),
    };

    const newItem = await createItem(payload);
    setItems([newItem, ...items]);

    setText("");
    setFontColor("#ffffff");
    setFontSize(40);
  }

  function onChange(updated, deleted = false) {
    setItems((prev) => {
      if (deleted) return prev.filter((i) => i._id !== updated._id);
      return prev.map((i) => (i._id === updated._id ? updated : i));
    });
  }

  function handleDragStart(index) {
    setDragIndex(index);
  }

  function handleDragOver(e, index) {
    e.preventDefault();
    if (dragIndex === index) return;

    setItems((prev) => {
      const updated = [...prev];
      const [moved] = updated.splice(dragIndex, 1);
      updated.splice(index, 0, moved);
      return updated;
    });

    setDragIndex(index);
  }

  function handleDrop() {
    setDragIndex(null);
  }

  const visibleItems = items.filter((i) => i.visible);

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 30 }}>
      <h2>Breaking News Manager</h2>

      <form
        onSubmit={add}
        style={{ display: "flex", gap: 12, marginBottom: 30 }}
      >
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Write a Breaking News..."
          style={{ flex: 1, padding: 12 }}
        />

        <input
          type="color"
          value={fontColor}
          onChange={(e) => setFontColor(e.target.value)}
          style={{ width: 50, height: 50 }}
        />

        <input
          type="number"
          min={10}
          max={200}
          value={fontSize}
          onChange={(e) => setFontSize(Number(e.target.value))}
          style={{ width: 80, padding: 10 }}
        />

        <button type="submit">Add</button>
      </form>

      <h3>All Items (Drag to reorder)</h3>
      {items.map((item, index) => (
        <div
          key={item._id}
          draggable
          onDragStart={() => handleDragStart(index)}
          onDragOver={(e) => handleDragOver(e, index)}
          onDrop={handleDrop}
        >
          <ItemRow item={item} onChange={onChange} />
        </div>
      ))}

      <h3 style={{ marginTop: 40 }}>Visible Items</h3>
      <div style={{ background: "#111", padding: 20, borderRadius: 10 }}>
        {visibleItems.map((item) => (
          <div
            key={item._id}
            style={{
              color: item.fontColor,
              fontSize: item.fontSize,
              padding: "10px 0",
              borderBottom: "1px solid #333",
            }}
          >
            {item.text}
          </div>
        ))}
      </div>
    </div>
  );
}
